<script lang="ts" setup>
// ================================
// IMPORTS
// ================================

// Vue
import { computed, ref } from "vue"
import { useI18n } from "vue-i18n"

// VueUse
import { useEventBus } from "@vueuse/core"

// Consent
import { CONSENT_PAGE_AFTER_SOURCE_MULTI_APPEND_BUS_KEY } from "@core/components/consent/consent.events"

// Stores
import { useAuthStore } from "@core/stores/auth.store"

// ================================
// INTERNATIONALIZATION
// ================================

const { t } = useI18n({
    messages: {
        fr: {
            title: "Consentements",
            breadcrumb: {
                accueil: "Accueil",
                consentements: "Consentements",
            },
            button: {
                add_consent: "Ajouter des compteurs",
            },
        },
    },
})

const getBreadcrumb = computed(() => {
    return [
        { icon: "pi pi-home", label: t("breadcrumb.accueil"), route: "/" },
        { icon: "pi pi-pencil", label: t("breadcrumb.consentements") },
    ]
})

// ================================
// SERVICES & STORES
// ================================

/**
 * Store d'authentification pour vérifier les permissions utilisateur
 */
const authStore = useAuthStore()

/** Visibilité du dialog d’ajout groupé bâtiments / compteurs (consentements) */
const isSourceMultiAppendDialogVisible = ref(false)

const busConsentPageAfterSourceMultiAppend = useEventBus<void>(
    CONSENT_PAGE_AFTER_SOURCE_MULTI_APPEND_BUS_KEY
)

// ================================
// INTERACTIONS UTILISATEUR
// ================================

/**
 * Ouvre le dialog d’ajout de plusieurs bâtiments et compteurs (parcours consentement).
 */
function onClickAddConsent(): void {
    isSourceMultiAppendDialogVisible.value = true
}

/**
 * Fin du parcours multi : notifie les cartes consentements / demandes pour recharger les listes.
 */
function onSourceMultiAppendDone(): void {
    busConsentPageAfterSourceMultiAppend.emit()
}
</script>

<template>
    <div class="page page-consentement">
        <!-- ================================ -->
        <!-- HEADER -->
        <!-- ================================ -->
        <HeaderPage
            :title="t('title')"
            :breadcrumb="getBreadcrumb"
            class-header="flex justify-between items-center flex-wrap gap-4"
        >
            <BaseButton
                v-if="
                    authStore.isClientHomeys && authStore.isEmployeWriteOrHigher
                "
                :label="t('button.add_consent')"
                icon="pi pi-plus"
                @click="onClickAddConsent"
            />
        </HeaderPage>

        <SourceMultiAppendDialog
            v-model:visible="isSourceMultiAppendDialogVisible"
            @done:form="onSourceMultiAppendDone"
        />

        <!-- ================================ -->
        <!-- CARTE DES DEMANDES DE CONSENTEMENT (client Homeys uniquement) -->
        <!-- ================================ -->
        <ConsentRequestCard v-if="authStore.isClientHomeys" class="mt-6" />

        <!-- ================================ -->
        <!-- CARTE DES CONSENTEMENTS -->
        <!-- ================================ -->
        <ConsentCard class="mt-6" />
    </div>
</template>
